const Sentry = require('@sentry/vue');
const { BrowserTracing } = require('@sentry/tracing');

const env = process.env.NODE_ENV || 'development';

const requiredOptions = ['dsn', 'router'];

const validateOptions = (opts) => {
  if (!opts || typeof opts !== 'object') {
    throw new Error('Sentry: Missing/Invalid options provided');
  }

  for (let i = 0; i < requiredOptions.length; i += 1) {
    const key = requiredOptions[i];

    if (!opts[key]) {
      throw new Error(`Sentry: Missing required opts.${key} param`);
    }
  }

  if (!opts.Vue && !opts.app) {
    throw new Error('Sentry: Missing required opts.Vue (vue2) or opts.app (vue3) param');
  }
};

module.exports.client = Sentry;

/**
 * Setup Sentry in the browser
 * @param opts - Options used to configure Sentry
 * @param opts.Vue - Vue module (for vue 2)
 * @param opts.app - Vue app instance (for vue 3)
 * @param opts.router - Vue router to use for setting up tracing
 * @param opts.dsn - Sentry DSN for the app
 * @param [opts.tracesSampleRate] - Same rate for traces, defaults to 1.0
 * @param [opts.env] - Environment Sentry is being ran in. Defaults to process.env.NODE_ENV.
 * @param [opts.release] - Current release/version of the app.
 *  Normally a commit hash. Defaults to process.env.COMMIT_HASH
 */
module.exports.init = (opts) => {
  validateOptions(opts);

  const environment = opts.env || env;
  const release = environment === 'development' ? null : (
    opts.release || process.env.COMMIT_HASH
  );

  const initOptions = {
    dsn: opts.dsn,
    tracesSampleRate: parseFloat(opts.tracesSampleRate || '1.0'),
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(opts.router),
        tracingOrigins: [/[^.\s]+\.tagboard\.com/],
      }),
    ],
    environment,
    release,
  };

  if (opts.Vue) {
    initOptions.Vue = opts.Vue;
  }

  if (opts.app) {
    initOptions.app = opts.app;
  }

  Sentry.init(initOptions);
};
